export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"connectToDevTools": false, "httpLinkOptions": {"browserHttpEndpoint": "/graphql", "httpEndpoint": "http://localhost:3000/graphql", "credentials": "include", "fetchOptions": {"mode": "cors"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}